import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Channel } from './channels.models';
import {
  NEWSFEED_CHANNELS_FEATURE_KEY,
  newsfeedChannelsAdapter,
  NewsfeedChannelsState,
  selectSponsoredChannel,
  selectSubscribedChannel,
  selectValidChannel,
} from './channels.reducer';

const { selectAll } = newsfeedChannelsAdapter.getSelectors();

export const getChannelsState = createFeatureSelector<NewsfeedChannelsState>(NEWSFEED_CHANNELS_FEATURE_KEY);
export const getIsLoaded = createSelector(getChannelsState, (state: NewsfeedChannelsState) => state.loaded);
export const getChannels = createSelector(getChannelsState, (state: NewsfeedChannelsState) =>
  selectAll(state).filter(selectValidChannel)
);
export const getSponsoredChannels = createSelector(getChannels, (channels: Channel[]) =>
  channels.filter(selectSponsoredChannel)
);
export const getSubscribedChannels = createSelector(getChannels, (channels: Channel[]) =>
  channels.filter(selectSubscribedChannel)
);
